import OtpVerify from "./pages/pages/OtpVerify";
import MyProfile from "./pages/profiles/MyProfile";

export const Routes = {
    // pages
    Presentation: { path: "/" },
    DashboardOverview: { path: "/dashboard/overview" },
    MyProfile: { path: "/profiles/myprofile" },
    
    Team: { path: "/team/team" },
    Team_Employee: { path: "/team/employee" },
    Team_Driver: { path: "/team/driver" },
    Team_Partner: { path: "/team/partner" },

    utils_appDownload: {path:"/downloads"},
    
    
    Vehicles: { path: "/vehicles" },
    AddVehicle: { path: "/vehicles/add" },

    Trails: { path: "/routes" },
    
    Trips: { path: "/trips" },


    Settings: { path: "/settings" },
    Upgrade: { path: "/upgrade" },
    RoutesTable: { path: "/tables/routes-master" },
    BootstrapTables: { path: "/tables/bootstrap-tables" },
    Billing: { path: "/page/billing" },
    Invoice: { path: "/page/invoice" },
    Signin: { path: "/pages/sign-in" },
    OtpVerify: { path: "/page/OtpVerify" },
    Signup: { path: "/page/sign-up" },
    ForgotPassword: { path: "/page/forgot-password" },
    ResetPassword: { path: "/page/reset-password" },
    Lock: { path: "/page/lock" },
    NotFound: { path: "/page/404" },
    ServerError: { path: "/page/500" },

    // docs
    DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" },

    // components
    Accordions: { path: "/components/accordions" },
    Alerts: { path: "/components/alerts" },
    Badges: { path: "/components/badges" },
    Widgets: { path: "/widgets" },
    Breadcrumbs: { path: "/components/breadcrumbs" },
    Buttons: { path: "/components/buttons" },
    Forms: { path: "/components/forms" },
    Modals: { path: "/components/modals" },
    Navs: { path: "/components/navs" },
    Navbars: { path: "/components/navbars" },
    Pagination: { path: "/components/pagination" },
    Popovers: { path: "/components/popovers" },
    Progress: { path: "/components/progress" },
    Tables: { path: "/components/tables" },
    Tabs: { path: "/components/tabs" },
    Tooltips: { path: "/components/tooltips" },
    Toasts: { path: "/components/toasts" },
    WidgetsComponent: { path: "/components/widgets" }
};